export default {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  'SAAS-TRAINING': {
    TITLE: 'Nuevos usuarios en SaaS',
    KPI: {
      TOTAL: 'Total usuarios',
      TOTAL_TOOLTIP: 'Número total de usuarios SaaS que cumplen los filtros aplicados.',
      CONTACTED: 'Contactados',
      CONTACTED_TOOLTIP: 'Usuarios que ya han sido contactados para la formación SaaS.',
      TRAINED: 'Formados',
      TRAINED_TOOLTIP: 'Usuarios que ya han completado la formación SaaS.',
      PENDING_TRAINING: 'Pendientes de formar',
      PENDING_TRAINING_TOOLTIP: 'Usuarios que todavía no han recibido la formación SaaS.',
    },
    FILTERS: {
      SEARCH: 'Buscar',
      SEARCH_PLACEHOLDER: 'Buscar por nombre, apellidos o email',
      ENTITY: 'Empresa',
      ENTITY_SEARCH: 'Buscar empresa...',
      ENTITY_SEARCH_HINT: 'Escribe 3 caracteres para buscar la empresa',
      ENTITY_EMPTY: 'No hay empresas disponibles',
      ENTITY_EMPTY_FILTER: 'No se encontraron empresas',
      CONTACTED: 'Contactado',
      TRAINED: 'Formado',
      CREATED_RANGE: 'Fecha de alta',
      CONTACTED_RANGE: 'Rango contactado',
      TRAINED_RANGE: 'Rango formado',
      CLEAR: 'Limpiar filtros',
      BUTTON: 'Filtros',
      BUTTON_COUNT_SINGULAR: '1 filtro',
      BUTTON_COUNT_PLURAL: '{{count}} filtros',
      SIDEBAR_TITLE: 'Filtros',
      APPLY: 'Aplicar filtros',
      RESET_TOOLTIP: 'Quitar filtros',
    },
    TABLE: {
      TITLE: 'Usuarios SaaS',
      HEADER: {
        ID: 'Id',
        FIRSTNAME: 'Nombre',
        LASTNAME: 'Apellidos',
        EMAIL: 'Email',
        COMPANY: 'Empresa',
        ROLE: 'Rol',
        CREATED_AT: 'Fecha alta',
        CONTACTED_AT: 'Contactado',
        TRAINED_AT: 'Formado',
      },
      BODY: { NO: 'No' },
      NO_DATA: 'No hay usuarios con los filtros seleccionados',
    },
    BULK: {
      SELECTED: '{{count}} seleccionados',
      MARK_CONTACTED: 'Marcar contactados',
      MARK_TRAINED: 'Marcar formados',
      CLEAR_CONTACTED: 'Desmarcar contactados',
      CLEAR_TRAINED: 'Desmarcar formados',
      MARK_TITLE: 'Marcar fecha',
      CLEAR_TITLE: 'Desmarcar fecha',
      MARK_MESSAGE: 'Vas a marcar como {{action}} a {{count}} usuarios. Elige la fecha a aplicar.',
      CLEAR_MESSAGE: 'Vas a desmarcar {{action}} de {{count}} usuarios.',
      ACTION_CONTACT: 'contactados',
      ACTION_TRAINING: 'formados',
      DATE: 'Fecha',
      DATE_REQUIRED: 'Debes seleccionar una fecha',
    },
    SUCCESS: {
      HEADER: 'Éxito',
      BULK_UPDATED: '{{updated}} actualizados, {{skipped}} omitidos',
    },
    ERRORS: {
      GENERIC_ERROR: 'Ha ocurrido un error',
      USER_IDS_NOT_BLANK: 'Debes seleccionar al menos un usuario',
      DATE_RANGE_INVALID: 'El rango de fechas no es válido',
      ENTITY_ID_WRONG: 'La empresa seleccionada no es válida',
      START_DATE_WRONG: 'La fecha de inicio no es válida',
      END_DATE_WRONG: 'La fecha de fin no es válida',
      CONTACTED_FROM_WRONG: 'La fecha de contacto desde no es válida',
      CONTACTED_TO_WRONG: 'La fecha de contacto hasta no es válida',
      TRAINED_FROM_WRONG: 'La fecha de formación desde no es válida',
      TRAINED_TO_WRONG: 'La fecha de formación hasta no es válida',
    },
  },
};
